import {useInjection} from 'dna-react-ioc'
import {TTeamManagementFilterStore} from '@/pages/TeamManagement/components/TeamManagementFilter'
import {TeamManagementFiltersStoreSymbol} from '@/pages/TeamManagement/TeamManagement'

export * from './TeamManagementFiltersStore'

export const useTeamManagementFiltersStore = () => useInjection<TTeamManagementFilterStore>(TeamManagementFiltersStoreSymbol)
